import { useRef } from 'react';
import timedOutIcon from '../assets/icons/timedOut.svg';
import Button from './Button';
import { useDispatch } from 'react-redux';
import { resetTimedOutModal } from '../store/reducers/timedOutReducer';
import { getToken } from '../services/api/axios';

type TimedOutProps = {
	isModalOpen: boolean;
	titleMessage: string;
	subTitleMessage: string;
};

const TimedOutModal = ({
	titleMessage,
	subTitleMessage,
	isModalOpen,
}: TimedOutProps) => {
	const ref = useRef<HTMLDivElement>(null);
	const dispatch = useDispatch();
	const onClickRefresh = async () => {
		dispatch(resetTimedOutModal());
		const updatedToken = await getToken();
		sessionStorage.setItem(
			(process.env.REACT_APP_SCOPES as string) || '',
			updatedToken || '',
		);
		window.location.reload();
	};

	return (
		<>
			{isModalOpen ? (
				<div className="fixed min-w-[100vw] bg-black bg-opacity-60 min-h-[100vh] z-[100] flex justify-center items-center">
					<div
						ref={ref}
						className="w-[650px] h-[220px] flex flex-col border-2 rounded-lg"
					>
						<div className="flex items-center p-6 h-[150px] bg-rcrm-light-blue border-b-2 border-rcrm-primary-border-blue gap-2">
							<div>
								<img
									className="w-14 h-14"
									src={timedOutIcon}
									alt=""
								/>
							</div>
							<div className="flex-col">
								<div className="flex justify-between gap-x-2 items-center">
									<div className="font-semibold text-xl">
										{titleMessage}
									</div>
								</div>
								<div>{subTitleMessage}</div>
							</div>
						</div>
						<div className="p-4 h-[80px] bg-white">
							<div className="flex justify-end gap-x-2">
								<Button
									label="Refresh"
									onButtonClick={onClickRefresh}
									buttonStyle="bg-rcrm-primary-blue"
									labelStyle="text-white"
								/>
							</div>
						</div>
					</div>
				</div>
			) : null}
		</>
	);
};

export default TimedOutModal;
